<template>
  <div class="bills-box">
    <nav-index :title="'月结账单'"/>
    <tabs @changeTaaab="changeTaaab" ref="tabs" :tabs="['待月结','已结清']"/>
    <div class="order-card-block">
      <div v-if="showEmyptyImg && !billsLoading">
          <div class="none-list">
              <img src="../../assets/images/none.svg" alt="">
              <div class="none">暂无月结订单</div>
          </div>
      </div>
      <div v-else>
        <BillsCard v-for="(billInfo,i) in billsInfo" :key="i" :isLoading="isLoading" :billInfo="billInfo" @pay="payBills" @goBillsDetailsPage="goBillsDetailsPage"></BillsCard>
      </div>
    </div>
  </div>
</template>

<script>
import NavIndex from '../../components/nav/index.vue'
import Tabs from '../../components/tabs/index.vue'
import BillsCard from '../../components/card/BillsCard.vue'
import { queryAllMonthlyPayOrder, submitWechatPay, wxSdk, updateOrderByOidList } from '@/api/api'
import { getopenIdByCode } from '@/utils/index';
const seo = require('../../../config/index')
import wx from "weixin-js-sdk";
// import moment from 'moment'
import {Toast} from 'vant'

export default {
name: 'Bills',
components: {
  NavIndex,
  Tabs,
  BillsCard,
},
created(){
  this.$bus.$on('changeTaaab', this.changeTaaab)
  getopenIdByCode()
},
mounted(){
  this.tabId = this.$route.query.tabId ? this.$route.query.tabId : '0'
  this.$refs.tabs.changeTab(Number(this.tabId), true)
  if(this.tabId === '0'){
    this.getBillsData('3')
  } else {
    this.getBillsData('5')
  }
},
destroyed(){
},
data:()=>{
  return {
    tabId: '0',
    billsInfo:[],
    showEmyptyImg: false,
    billsLoading: false,
    showScrollTopBtn: false,
    statusTemp: '',
    isLoading: false,
    userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo'))[0] : {}
  }
},
methods:{
  getBillsData(payment){
    this.showEmyptyImg = false
    this.billsLoading = true
    let uidTemp = Object.keys(this.userInfo).length > 0 ? this.userInfo.uid : ''
    // 查询账单
    queryAllMonthlyPayOrder({ uid: uidTemp, payment: [payment] }).then(res=>{
        this.billsInfo = []
        let resData = res.data.data
        if(resData.length > 0){
          resData.forEach((item)=>{
            let temp = {}
            temp.orderAmount = item.orderAmount
            temp.payable = item.totalPrice
            temp.date = item.date.split('-')[0] + '年' + item.date.split('-')[1] + '月'
            temp.oidList = item.oidList
            temp.payment = payment
            temp.isLoading = false
            this.billsInfo.push(temp)
          })
        } else {
          this.showEmyptyImg = true
        }
        this.billsLoading = false
    })
  },
  // 前往账单详情页
  goBillsDetailsPage(billInfo){
    let payment = this.tabId === '0' ? '3' : this.tabId === '1' ? '5' : '3'
    let oidList = JSON.stringify(billInfo.oidList)
    this.$router.push({ path:'/bills-detail', query:{ bills: payment, oidList: oidList, tabId: this.tabId } })
  },
  changeTaaab(id){
    this.tabId = String(id)
    if(String(id) === '0'){
      this.getBillsData('3')
    } else if(String(id) === '1'){
      this.getBillsData('5')
    }
  },
  // 结清账单
  payBills(billInfo){
    let params = {}
    params.oid = Date.now() // 给微信支付的订单号
    params.price = billInfo.payable // 金额
    params.title = '【月结账单】' + billInfo.date
    params.openid = localStorage.getItem('openid') ? localStorage.getItem('openid') : ''
    // 打开loading
    const index = this.billsInfo.findIndex(item => item.oidList === billInfo.oidList)
    if (index !== -1) {
      this.billsInfo[index].isLoading = true
    }
    submitWechatPay(params).then(res=>{
        this.wxSdk(res.data, billInfo)
    })
  },
  wxSdk(payRes, billInfo){
        let url = seo.config.homeUrl + this.$route.fullPath
          let my = this
          wxSdk({ url:url }).then(res=>{
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: seo.config.wxConfig.appId, // 必填，公众号的唯一标识
              timestamp: res.data.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.data.data.noncestr, // 必填，生成签名的随机串
              signature: res.data.data.signature,// 必填，签名
              jsApiList: ["checkJsApi", "chooseWXPay", "updateAppMessageShareData", "updateTimelineShareData"] // 必填，需要使用的JS接口列表
            });
            wx.ready(function() { /* 微信支付 */
                wx.chooseWXPay({
                    appId: payRes.appId,
                    timestamp: payRes.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                    nonceStr: payRes.nonceStr, // 支付签名随机串，不长于 32 位
                    package: payRes.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                    signType: payRes.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                    paySign: payRes.paySign, // 支付签名
                    // 支付成功
                    success: function (res) {
                        console.log('支付成功', res)
                        if(res.errMsg === 'chooseWXPay:ok'){
                            let payment = '5' // 5-月结微信付款成功 1-微信支付 2-支付宝支付
                            updateOrderByOidList({ oidList: billInfo.oidList, order_status: 'orderComment', payment: payment,
                                                   date: billInfo.date, payable: billInfo.payable, uid: my.userInfo.uid }).then(()=>{
                                my.getBillsData('3')  
                                Toast('付款成功')
                                // 关闭loading
                                const index = my.billsInfo.findIndex(item => item.oidList === billInfo.oidList)
                                if (index !== -1) {
                                  my.billsInfo[index].isLoading = false
                                }
                            })
                        }
                    },
                    // 支付取消
                    cancel: function(res){
                        if(res.errMsg === 'chooseWXPay:cancel'){
                            Toast('支付取消');
                            // 关闭loading
                            const index = my.billsInfo.findIndex(item => item.oidList === billInfo.oidList)
                            if (index !== -1) {
                              my.billsInfo[index].isLoading = false
                            }
                        }
                    },
                    // 支付失败
                    fail: function(res){
                        console.log(res)
                        Toast('支付失败');
                        // 关闭loading
                        const index = my.billsInfo.findIndex(item => item.oidList === billInfo.oidList)
                        if (index !== -1) {
                          my.billsInfo[index].isLoading = false
                        }
                    }
                });
            })
        })
    },
},
}
</script>

<style scoped lang="scss">
.bills-box {
  min-height: 100vh;
  .order-card-block {
    padding: 95px 0 10px;
    padding-bottom: calc(10px + constant(safe-area-inset-bottom));
    padding-bottom: calc(10px + env(safe-area-inset-bottom));
  }
}
.header {
  display: flex;
  align-items: center;
  margin: 10px 10px 0 10px;
  input {
      width: 100%;
      border-radius: 5px;
      height: 40px;
      border: 1px solid #eee;
      padding-left: 15px;
      box-sizing: border-box;
      -webkit-appearance: none;
  }
  div {
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      margin-top: 10px;
      width: 40px;
      min-width: 48px;
      padding-right: 10px;
  }
  .searchImg {
      width: 20px;
      position: absolute;
      right: 20px;
  }
}
.none-list {
  margin: 60px auto 20px;
  width: 100%;
  max-width: 625px;
  .none {
      margin: 10px 0 0;
      color: #969699;
  }
  img {
      min-height: 142px;
  }
}
.load-more {
  text-align: center;
  color: #969699;
  padding: 0px 0 5px 0;
  font-size: 14px;
}
</style>